export default __webpack_public_path__ + "static/ocac-5e8a3b3f3fd48466ea0508a9b0b75cf0.jpeg";